import angular from 'angular';
import ComponentsModule from '../components-module';
import template from './confirm-dialog.html';

const COMPONENT_NAME = 'confirmDialog';

angular.module (ComponentsModule)
  .component (COMPONENT_NAME, {
    template,

    bindings: {
      resolve: '<',
      close: '&',
      dismiss: '&'
    },

    controller: function (KeyboardShortcutService) {
      const $ctrl = this;

      $ctrl.$onInit = () => {
        $ctrl.message = $ctrl.resolve.message;
        $ctrl.title = $ctrl.resolve.title || 'confirm-dialog.header.default.text';
        $ctrl.confirmText = $ctrl.resolve.confirmText || 'confirm-dialog.confirm.default.label';
        $ctrl.cancelText = $ctrl.resolve.cancelText || 'confirm-dialog.cancel.default.label';

        KeyboardShortcutService.hideAndPush({
          'escape': {
            label: $ctrl.cancelText,
            action: () => {
              $ctrl.dismiss();
            }
          }
        });
      };

      $ctrl.$onDestroy = () => {
        KeyboardShortcutService.pop();
      };

      $ctrl.ok = () => {
        $ctrl.close();
      };

      $ctrl.cancel = () => {
        $ctrl.dismiss();
      };
    }
  });

export default COMPONENT_NAME;
